import defaultColor from "@/components/color";

export default {
    cptDataForm:{
        dataSource: 1, pollTime: 0, dataText: '{"value":22}',
    },
    attribute:{
        title:'速度',titleSize:12,titleColor:'#ddd',titleOffsetTop:75,min:0,max:100,
        detailSize:25,detailColor:'#ddd',detailOffsetTop:40,
        lineWidth:3,color1:defaultColor[1],color2:defaultColor[2],color3:defaultColor[3],itemColor:'#8FC7FF',
        pointerOffsetTop:0,
        radius:100,
        startAngle:225,endAngle:-45,
        axisLabel: {
            show: true,
            distance: 10,
            color: '#999',
            fontSize: 12,
        },
        axisTick: {
            show: true,
            length: 5,
            distance: 5,
            lineStyle: {
                width: 1,
                color: '#ccc'
            }
        },
        pointer: {
            length: 75,
            width: 6,
            itemStyle: {
                color: '#35D0E6'
            }
        },
        enableGradual:true,
        cptTableData: [{ "name": "指标", "value": "", "namekey": "value" }]
    },
}
